<template>
  <div class="tomv_test about page">
    <DashHeader />
    <h1>TomV Test Page</h1>
    <p>
      <router-link to="/">BACK</router-link>
    </p>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "News",
  components: {
    DashHeader
  }
};
</script>
